import styled from 'styled-components';

import { animation } from '../../animations/styles';
import theme from '../../theme';

export const Container = styled.div`
    --gap: calc(100vw / 80);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;

    opacity: 0;

    animation: ${props => animation(props.animation)};
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const ImageGallery = styled.div`
    width: 100%;
    column-count: 2;
    padding: var(--gap);
    font-size: var(--gap); /* column gap */

    @media only screen and ${theme.mediaQueries.gteSmall} {
        column-count: 3;
    }
`;

export const ImageGalleryItem = styled.div`
    margin-bottom: var(--gap);
`;

export const ImageGalleryItemImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const ImageGallerySeparator = styled.div`
    width: 100%;
    text-align: center;
    height: 100px;
`;
